import styled from 'styled-components';

import {flipOnLTR} from '~/shared/theme/flipOnLTR';

export const Line = styled.div<{borderTop?: boolean; paddingTop?: boolean}>`
  display: flex;
  border-top: ${({borderTop, theme}) => (borderTop ? `1px solid ${theme.userReport.showOrder.borderLineColor}` : '0')};
  ${({paddingTop}) =>
    paddingTop &&
    `
    margin-top: 12px;
    padding-top: 12px;
  `}
`;
export const LineTitle = styled.div`
  font-weight: bold;
  ${flipOnLTR`margin-left: 10px;`};
`;

export const Col = styled.div<{singleRow?: boolean}>`
  flex-direction: ${({singleRow}) => (singleRow ? 'row' : 'column')};
  ${({singleRow}) =>
    singleRow &&
    `
    justify-content: flex-end;
  `}
  display: flex;
  flex: 1;
`;

export const InnerRow = styled.div<{flexStart?: boolean; bold?: boolean}>`
  display: flex;
  justify-content: ${({flexStart}) => (flexStart ? 'flex-start' : 'space-between')};
  font-weight: ${({bold: isBold}) => (isBold ? 'bold' : 'normal')};
`;
